import React from "react";
import ConversationStarterInput from "./ConversationStarterInput";

interface ConversationStarter {
  id: string;
  suggestion: string;
}

interface ConversationStartersSectionProps {
  starters: ConversationStarter[];
  onChange: (starters: ConversationStarter[]) => void;
  disabled?: boolean;
}

const ConversationStartersSection: React.FC<
  ConversationStartersSectionProps
> = ({ starters, onChange, disabled = false }) => {
  const addStarter = () => {
    onChange([...starters, { id: Date.now().toString(), suggestion: "" }]);
  };

  const updateStarter = (id: string, suggestion: string) => {
    onChange(starters.map((s) => (s.id === id ? { ...s, suggestion } : s)));
  };

  const removeStarter = (id: string) => {
    onChange(starters.filter((s) => s.id !== id));
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <label className="block text-gray-700 font-medium">
          Conversation Starters
        </label>
        <button
          type="button"
          onClick={addStarter}
          disabled={disabled}
          className="px-3 py-1 bg-brand-primary text-white rounded text-sm hover:bg-brand-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          + Add Starter
        </button>
      </div>

      {starters.length === 0 ? (
        <p className="text-sm text-gray-500 italic">
          No conversation starters yet. Add one to help users get started.
        </p>
      ) : (
        <div className="space-y-3">
          {starters.map((starter) => (
            <ConversationStarterInput
              key={starter.id}
              starter={starter}
              onUpdate={updateStarter}
              onRemove={removeStarter}
              disabled={disabled}
            />
          ))}
        </div>
      )}

      <p className="mt-2 text-sm text-gray-500">
        Add suggested prompts to help users start conversations with this agent.
      </p>
    </div>
  );
};

export default ConversationStartersSection;
